import { rejectNull } from "./rejectNull.js";

export function toTruthy<T>(items: T[]): NonNullable<T>[] {
  return items.filter((item) => item).map((item) => rejectNull(item));
}
